import React, { useEffect, useState } from "react";
import "./Projects.css";
import FadeInSection from "../../Hooks/FadeInSection";
import { Carousel } from "react-responsive-3d-carousel";
import "react-responsive-3d-carousel/dist/styles.css"; // make sure this is the correct CSS import

export default function Projects() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(max-width: 620px)");

    const update = () => setIsMobile(media.matches);
    update();

    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  const projects = [
    {
      title: "Avatar: The Last Airbender Memory Game",
      description:
        "A fun and interactive browser-based memory card game inspired by Avatar: The Last Airbender. Players must match pairs of character cards by flipping them two at a time. The game tracks the number of moves and resets upon completion, offering a polished and responsive user experience. Built using React, javascript, event handling, and basic game state logic to showcase strong fundamentals in front-end development and interactivity without frameworks.",
      movie:
        "https://res.cloudinary.com/darnycya/video/upload/v1753138731/Avatar_gif_bvopcd.mov",
      link: "https://avatar-memory-game.netlify.app/",
    },
    {
      title: "Code Roast Machine",
      description:
       "An interactive developer tool that analyzes user-submitted code and delivers structured, personality-driven feedback in a playful “roast” format. Users can select a programming language and roast mode (from gentle mentor to blunt senior), submit their code, and receive a breakdown including a roast summary, biggest offense, severity score, actionable critiques, and practical improvement advice. Built with React and TypeScript, the app features dynamic state management, animated UI feedback, and API-driven responses with graceful fallbacks. This project highlights front-end architecture, API integration, error handling, and thoughtful UX design layered with humor.",
      movie:
        "https://res.cloudinary.com/darnycya/video/upload/v1768531947/codemachine_ig8fxj.mov",
      link: "https://code-roast-machine.netlify.app/",
    },
    {
      title: "Dallas Cowboy Calculator",
      description:
        "A humorous, football-themed calculator inspired by the Dallas Cowboys fandom. It performs standard arithmetic operations with a custom UI and playful design tailored to the team’s branding. Built using vanilla JavaScript, the app demonstrates event-driven programming, modular logic, and responsive layout styling. This project merges functionality with personality, showcasing both technical skills and creativity in front-end development.",
      movie:
        "https://res.cloudinary.com/darnycya/video/upload/v1753138896/Calculator_dshehf.mov",
      link: "https://dallas-cowboy-calculator.netlify.app/",
    },
    {
      title: "Dallas Cowboy Calculator Roster",
      description:
        "A responsive web application that displays the current Dallas Cowboys player roster. The app fetches data from an external API and dynamically renders player information such as names, positions, and jersey numbers. Built with React, it leverages component-based architecture, hooks for state and lifecycle management, and clean UI design. This project demonstrates proficiency in API integration, dynamic rendering, and front-end architecture best practices.",
      movie:
        "https://res.cloudinary.com/darnycya/video/upload/v1753138971/cowoby_y4hvtw.mov",
      link: "https://dallas-cowboys-roster.netlify.app/",
    },
  ];

  // Convert each project into a carousel slide (JSX element)
  const carouselItems = projects.map((proj, index) => (
    <div key={index} className="carousel-slide">
      <a href={proj.link} target="_blank" rel="noopener noreferrer">
        <video
          src={proj.movie}
          autoPlay
          loop
          muted
          playsInline
          className="carousel-video"
        />
      </a>
      <div className="carousel-caption">
        <h5>{proj.title}</h5>
        <p>{proj.description}</p>
      </div>
    </div>
  ));

  return (
    <div className="projects-container">
      <div className="projects-header slide-in-right">
        <h3>..the experiments</h3>
      </div>
      <FadeInSection>
        <Carousel
          items={carouselItems}
          height={"580px"}
          width={isMobile ? "100%" : "400px"}
          interval={5000}
          startIndex={0}
          color="wheat"
          pauseOnHover={true}
          showArrows={false}
          showStatus={false}
          onChange={(currentIndex) =>
            console.log("Current slide:", currentIndex)
          }
        />
      </FadeInSection>
    </div>
  );
}
